import { z } from 'zod';

// Dražby z Obchodného vestníka (Týž. 21, plán §B2) — surový feed
// Slovensko.Digital datahub (`ov/raw_issues`), viď apps/api opendata-bulk-sync/
// auction-*.ts. Dva zdrojové XML formáty zjednotené do jedného riadku.
export const auctionListingSchema = z.object({
  id: z.string(),
  auctionType: z.enum(['exekucna', 'dobrovolna']),
  subType: z.string(),
  caseNumber: z.string().nullable(),
  predmet: z.string().nullable(),
  propertyType: z.string().nullable(),
  region: z.string().nullable(),
  district: z.string().nullable(),
  municipality: z.string().nullable(),
  auctionDate: z.string().nullable(),
  auctionPlace: z.string().nullable(),
  organizerName: z.string().nullable(),
  companyId: z.string().nullable(),
  publishedAt: z.string().nullable(),
});
export type AuctionListing = z.infer<typeof auctionListingSchema>;

export const auctionFeedResponseSchema = z.object({
  results: z.array(auctionListingSchema),
  total: z.number(),
  page: z.number(),
  pageSize: z.number(),
});
export type AuctionFeedResponse = z.infer<typeof auctionFeedResponseSchema>;
